export interface Maintainer {
  users: Users;
}


export interface Users {
  users: User[];
  selectors: any;
  error: string | null;
}


export interface User {
  email: string;
  name: string;
  position: string;
  center: number;
  country: string;
  role: UserRole;
  status: UserStatus;
  id?: number;
}


export enum UserRole {
  ADMINISTRATOR = 'ADMINISTRADOR',
  COLLABORATOR = 'COLABORADOR'
}


export enum UserStatus {
  ON = 'ACTIVO',
  OFF = 'DESACTIVO'
}
